// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__BE2UA","overlay":"Modal_overlay__b+zEz","body":"Modal_body__QBuaA","fadeIn":"Modal_fadeIn__zuilp"};